import { useLocation, useNavigate } from "react-router-dom";
import { useSearchHistory } from "../const/useSearchHistory";
import { useCallback, useRef, useEffect } from "react";
import { FiltersTypeImpl } from "@common/utils/filters";
import { SearchContextType } from "../../context/search";
import { getUrlConstructor } from "../const";
type UseSearchNavigation = {
  context: SearchContextType;
  pathname: string;
  previousContext?: string;
};

export const useSearchNavigation = ({
  context,
  pathname,
  previousContext,
}: UseSearchNavigation) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [, addToHistory] = useSearchHistory();
  const isSameSearchType = context.searchType?.toLowerCase() === pathname;
  const previousSearchContextRef = useRef<string | null>(
    previousContext || null
  );

  const searchNavigate = useCallback(
    (searchParams: Record<string, string | string[]>) => {
      previousSearchContextRef.current = previousContext || pathname;

      const constructedUrl = getUrlConstructor(context.searchType)(
        searchParams
      );

      const shouldShowBreadcrumb =
        previousSearchContextRef.current === pathname
          ? isSameSearchType
          : false;

      const url = `${constructedUrl}&mode=search`;
      const alreadyInSearch = /[?&]mode=search\b/.test(location.search);

      const commonState = {
        fromWidget: true,
        previous: shouldShowBreadcrumb
          ? previousSearchContextRef.current?.toLocaleUpperCase()
          : null,
        title: !shouldShowBreadcrumb ? context.searchType : null,
        label: `${context.searchType} SEARCH`,
        previousContext: previousSearchContextRef.current,
      };

      const state =
        context.searchType === FiltersTypeImpl.Tickets
          ? { ...commonState, defaultFilter: false }
          : commonState;

      addToHistory(constructedUrl);
      navigate(url, {
        state,
        replace: alreadyInSearch,
      });
    },
    [
      addToHistory,
      context.searchType,
      pathname,
      navigate,
      location.search,
      previousContext,
    ]
  );

  return searchNavigate;
};
